<template>
  <div class="home-content">
    <!-- 侧边栏 -->
    <aside>
      <div class="logo">
        <img src="@/assets/images/logoBig.png" alt @click="to_index" />
      </div>
      <div class="menu">
        <el-scrollbar style="height: 100%" ref="myScrollbar">
          <el-menu
            :deault-active="$route.path"
            class="el-menu-vertical-demo"
            :default-openeds="openSubs"
            :unique-opened="true"
            background-color="#28333e"
            text-color="#fff"
            router
          >
            <NavMenu :navMenus="menuList"></NavMenu>
          </el-menu>
        </el-scrollbar>
      </div>
    </aside>
    <!-- 右侧头部及内容 -->
    <div class="right-content">
      <!-- 头部 -->
      <HomeHead></HomeHead>
      <!-- tab标签 -->
      <Tabs></Tabs>
      <!-- 内容 -->
      <div class="main-content">
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <keep-alive>
          <iframePage v-show="$route.meta.keepAlive"></iframePage>
        </keep-alive>
      </div>
    </div>
    <!-- 动态变单生成弹窗 -->
    <FormMaking :initData="formMakingData" :isShow="showFormMaking"></FormMaking>
  </div>
</template>
<script>
import api from "@/api/index.js";
import { dealData } from "@/utils/auth.js";
import HomeHead from "./header/header.vue";
import NavMenu from "./aside/navMenu.vue";
import iframePage from "../iframe/index.vue";
import Tabs from "./tabs/tabs.vue";
import FormMaking from "../formMaking/index.vue";
Array.prototype.remove = function(val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};
export default {
  name: "Home",
  components: { HomeHead, NavMenu, Tabs, FormMaking, iframePage },
  data() {
    return {
      showFormMaking: true,
      formMakingData: ""
    };
  },
  computed: {
    menuList() {
      return this.$store.state.menuList;
    },
    // 设置展开的summenu
    openSubs() {
      let result = this.getids(this.menuList, [], this.path);
      let openids = [];
      for (var i = 0; i < result.length; i++) {
        if (result[i].path === this.path) continue;
        openids.push(result[i].id + "");
      }
      return openids;
    },
    path() {
      if (this.$route.path.includes("iframe")) {
        return unescape(this.$route.fullPath);
      }
      if (this.$route.meta.hidden) {
        return this.$route.matched[1].path;
      }
      return this.$route.path + "";
    }
  },
  mounted() {
    //设置全局函数，接受iframe返回的值
    window.addEventListener("message", this.getIframeData, false);
    this.getMenu()
  },
  methods: {
    // 跳转到首页
    to_index() {
      this.$router.push("/");
      this.$store.commit("SET_ACTIVE_INDEX", 0);
    },
    getids(array, childs, path) {
      if(array&&array.length>0)
      for (var i = 0; i < array.length; i++) {
        var item = array[i];
        if (item.path === path) {
          childs.push(item);
          return childs;
        }
        if (item.list && item.list.length > 0) {
          childs.push(item);
          var rs = this.getids(item.list, childs, path);
          if (rs) {
            return rs;
          } else {
            childs.remove(item);
          }
        }
      }
      return false;
    },
    async getMenu() {
      let data = {
        userId: this.$store.state.userInfo.userId,
        communityId: this.$store.state.userInfo.communityId,
        viewType: 1
      };
      let res = await this.$http.get(api.getMenu,{params:data});
      if (res.isSucceed) {
        dealData(res.rows);
        this.$store.commit("SET_ROUTERS", res.rows);
        // this.$store.commit("DEL_TABS");
      }
    },
    getIframeData(e) {
      if (e.data === "nav.flush") {
        this.getMenu();
      } else if (event.data.formMaking !== undefined) {
        this.showFormMaking = !this.showFormMaking;
        this.formMakingData = e.data.formMaking;
      }
    }
  }
};
</script>
<style lang='less' scoped>
@import url("./index.less");
</style>
<style lang='less'>
@import url("./ele-index.less");
</style>
